import CachedIcon from "mdi-react/CachedIcon";
import React, { useEffect, useState } from "react";
import { Form, Button, InputGroup, Dropdown } from "react-bootstrap";
import TableComponent from "../TableComponent";
import {
  Checked,
  CustomerAccountSelectIcon,
  DownloadIcon,
  FilterCollapseIcon,
  FilterTwoIcon,
  LoaderIcon,
  ViewIcon,
  EmailIcon,
  FormAllIcon,
  ChartPieSliceIcon,
} from "../Icons";
import useDebounce, {
  useLocalStorage,
  useQueryParams,
} from "../../utils/hooks";
import { useQuery } from "react-query";
import { useAuth } from "../../hooks/useAuth";
import { format } from "date-fns";
import queryString from "query-string";
import { formatDate, paginationOptions } from "../../utils/helpers";
import DotsVerticalIcon from "mdi-react/DotsVerticalIcon";
import ReactPaginate from "react-paginate";
import NoTableItem from "../utils/NoTableItem";
import Select from "react-select";
import { isEmpty, truncate } from "lodash";
import { useNavigate, useOutletContext } from "react-router-dom";
import PartnerDetails from "./PartnerDetails";
import PrincingModal from "./PrincingModal";
import DocumentUpload from "./DocumentUpload";
import ConfirmDialog from "../ConfirmDialogue";
import { toast } from "react-toastify";
import ContactPartnerModal from "./ContactPartnerModal";
import FormSelectorModal from "../CustomersEmail/FormSelectorModal";
import { HoverDropDown } from "../Component";
const partnerStatuses = [
  { label: "Verified", value: "verified" },
  { label: "Unverified", value: "unverified" },
];

export default function EBCompanyList() {
  const navMetaData = useOutletContext();
  const { backendUrl, token } = useAuth();
  const [showFilter, setShowFilter] = useLocalStorage(
    "showEBCompanyFilter",
    true
  );

  const [showCompanyBranchModal, setShowCompanyModal] = useState(false);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [multiSelectionMode, setMultiSelectionMode] = useState(false);
  const [selectedPartnerDetails, setSelectedPartnerDetails] = useState(null);
  const [showDocumentUploadModal, setShowDocumentUploadModal] = useState(false);
  const [partnerList, setPartnerList] = useState([]);
  const [showContactPartnerModal, setShowContactPartnerModal] = useState(false);
  const { user } = useAuth();
  const initialFilterParams = {
    companyName: "",
    startDate: "",
    endDate: "",
    companyID: "",
  };
  const [queryParams, setQueryParams] = useQueryParams({
    page: 1,
    limit: 40,
    ...initialFilterParams,
  });
  const [filterParams, setFilterParams] = useState({
    ...initialFilterParams,
    ...queryParams,
  });
  const [multiSelected, setMultiSelected] = useState([]);
  // const [selectedStatus, setSelectedStatus] = useState('verified')

  const [showFormSelectorModal, setShowFormSelectorModal] = useState(false);

  const fetchInvexPartners = async query => {
    // const res = await fetch(
    //   `${backendUrl}/api/partnership/invexerp-partners?${queryString.stringify(
    //     query
    //   )}`,
    //   {
    //     method: "GET",
    //     credentials: "include",
    //     headers: {
    //       Accept: "Application/json",
    //       "Content-Type": "Application/json",
    //       ...(token ? { Authorization: `Bearer ${token}` } : {}),
    //     },
    //   }
    // );
    // if (!res.ok) {
    //   toast.error("unable to get partners");
    //   return [];
    // }
    // const data = await res.json();

    // return data;

    return {
      success: true,
      data: [
        {
          id: "27",
          is_verified: 0,
          partner_type: "sales",
          company_name: "ABC LLC",
          address_line_1: "25222 Lockspur Drive  Richmond",
          address_line_2: "",
          company_email: "fexspace@gmail.com",
          company_website: "excellentbridge.com",
          country: "Nigeria",
          state: "Rivers State",
          city: "Port Harcourt",
          zip_code: "510027",
          first_name: "Promise",
          last_name: "Emeka",
          title: "CTO",
          personal_email: "admin@invexerp.com",
          country_code: "No Code Available",
          phone_line: "08034589805",
          core_focus:
            '["financial_solutions","human_resource","business_consulting","it_services",""]',
          solution: '["erp","accounting","human_resource","payroll","crm"]',
          industry: '["healthcare","hospitality","finance"]',
          business_size: "100+",
          resell: '["Distributor",""]',
          annual_revenue: "10m_25m",
          why_interested: "Trial",
          createdAt: "2026-02-23T09:46:10.174Z",
          updatedAt: "2026-02-23T09:46:10.175Z",
          banner_image: null,
          description: null,
          documents: [],
        },
        {
          id: "26",
          is_verified: 0,
          partner_type: "sales",
          company_name: "Recon Consulting Limited ",
          address_line_1: "C17 Kachia Road, by MMAB Cable Industry,Kaduna",
          address_line_2: "Kaduna, Nigeria.",
          company_email: "info@reconconsultingltd.com",
          company_website: "www.reconconsultingltd.com",
          country: "Nigeria",
          state: "Kaduna State",
          city: "Kaduna ",
          zip_code: "234",
          first_name: "Juwon",
          last_name: "Adetayo",
          title: "Managing Partner",
          personal_email: "juwadess@gmail.com",
          country_code: "No Code Available",
          phone_line: "09099213345",
          core_focus:
            '["financial_solutions","business_consulting","it_services","Business Consulting, and the Computerization of Accounts"]',
          solution: '["erp"]',
          industry: '["manufacturing"]',
          business_size: "100+",
          resell: '["Other","Not yet."]',
          annual_revenue: "5m",
          why_interested:
            "This will enable us deploy the software to the clients of our audit firm in our group.",
          createdAt: "2025-08-26T17:00:17.187Z",
          updatedAt: "2025-08-26T17:00:17.187Z",
          banner_image: null,
          description: null,
          documents: [],
        },
        {
          id: "25",
          is_verified: 1,
          partner_type: "sales",
          company_name: "ExcellentBridge",
          address_line_1:
            "Block 26, Plot 8A, Admiralty way, Lekki Phase 1, Lagos",
          address_line_2: "",
          company_email: "emexon4love@yahoo.com",
          company_website: "excellentbridge.com",
          country: "Nigeria",
          state: "Rivers State",
          city: "PHC",
          zip_code: "510027",
          first_name: "Emeka",
          last_name: "Promise",
          title: "CEO",
          personal_email: "emexon4love@yahoo.com",
          country_code: "No Code Available",
          phone_line: "08034589805",
          core_focus: '["financial_solutions",""]',
          solution: '["erp"]',
          industry: '["oil_gas","finance"]',
          business_size: "1-9",
          resell: '["Sap",""]',
          annual_revenue: "5m",
          why_interested: "Happy to join",
          createdAt: "2025-06-22T12:22:38.540Z",
          updatedAt: "2025-06-22T12:22:38.540Z",
          banner_image: null,
          description: null,
          documents: [],
        },
        {
          id: "24",
          is_verified: 0,
          partner_type: "sales",
          company_name: "ExcellentBridge",
          address_line_1:
            "Block 26, Plot 8A, Admiralty way, Lekki Phase 1, Lagos",
          address_line_2: "",
          company_email: "promise@excellentbridge.com",
          company_website: "ExcellentBridge.com",
          country: "Nigeria",
          state: "Lagos State",
          city: "Lagos",
          zip_code: "105102",
          first_name: "Emeka",
          last_name: "Promise",
          title: "dd",
          personal_email: "promise@excellentbridge.com",
          country_code: "No Code Available",
          phone_line: "08034589805",
          core_focus:
            '["financial_solutions","human_resource","business_consulting",""]',
          solution: '["erp"]',
          industry: '["oil_gas","finance"]',
          business_size: "1-9",
          resell: '["Sap",""]',
          annual_revenue: "5m",
          why_interested: "eeee",
          createdAt: "2025-06-16T14:15:16.864Z",
          updatedAt: "2025-06-16T14:15:16.864Z",
          banner_image: null,
          description: null,
          documents: [],
        },
        {
          id: "23",
          is_verified: 1,
          partner_type: "partner",
          company_name: "Incless Co Inc",
          address_line_1:
            "Block 26, Plot 8A, Admiralty way, Lekki Phase 1, Lagos",
          address_line_2: "",
          company_email: "support@excellentbridge.com",
          company_website: "incless.io",
          country: "Nigeria",
          state: "Rivers State",
          city: "PHC",
          zip_code: "510027",
          first_name: "Emeka",
          last_name: "Promise",
          title: "CTO",
          personal_email: "support@excellentbridge.com",
          country_code: "No Code Available",
          phone_line: "08034589805",
          core_focus: '["financial_solutions","human_resource",""]',
          solution: '["erp","accounting"]',
          industry: '["oil_gas","finance"]',
          business_size: "1-9",
          resell: '["Sap","Microsoft Dynamics",""]',
          annual_revenue: "5m",
          why_interested: "We want to sell",
          createdAt: "2025-06-15T11:43:00.613Z",
          updatedAt: "2025-06-15T11:43:00.613Z",
          banner_image: null,
          description: null,
          documents: [],
        },
        {
          id: "22",
          is_verified: 1,
          partner_type: "sales",
          company_name: "ExcellentBridge Sales Ltd",
          address_line_1:
            "Block 26, Plot 8A, Admiralty way, Lekki Phase 1, Lagos",
          address_line_2: "",
          company_email: "emekapromise500@gmail.com",
          company_website: "excellentbridge.com",
          country: "Nigeria",
          state: "Rivers State",
          city: "Port Harcourt",
          zip_code: "510027",
          first_name: "Emeka",
          last_name: "Promise",
          title: "CTO",
          personal_email: "emekapromise500@gmail.com",
          country_code: "No Code Available",
          phone_line: "08034589805",
          core_focus: '["financial_solutions","human_resource",""]',
          solution: '["erp","accounting"]',
          industry: '["who_dist","oil_gas","finance"]',
          business_size: "10-99",
          resell: '["Sap","Microsoft Dynamics","Zoho"]',
          annual_revenue: "5m",
          why_interested: "To sell your product",
          createdAt: "2025-06-15T10:46:05.070Z",
          updatedAt: "2025-06-15T10:46:05.070Z",
          banner_image: null,
          description: null,
          documents: [],
        },
        {
          id: "21",
          is_verified: 0,
          partner_type: "sales",
          company_name: "Datarsen Ltd",
          address_line_1: "No. 13 Ada George Road",
          address_line_2: "",
          company_email: "accounts@datarsen.com",
          company_website: "www.datarsen.com",
          country: "Nigeria",
          state: "Rivers State",
          city: "Port Harcourt",
          zip_code: "500272",
          first_name: "Emuobosa",
          last_name: "Onerhime",
          title: "Founder",
          personal_email: "emuobosa@datarsen.com",
          country_code: "No Code Available",
          phone_line: "2347033698500",
          core_focus:
            '["financial_solutions","human_resource","business_consulting","it_services",""]',
          solution:
            '["erp","accounting","human_resource","payroll","inventory_management","invoicing","approval_management","crm"]',
          industry:
            '["oil_gas","who_dist","manufacturing","construction","real_estate"]',
          business_size: "1-9",
          resell:
            '["Other","We resell Data Privacy Solutions via Termageddon as a service but now want to sell products that benefit from such. "]',
          annual_revenue: "5m",
          why_interested:
            "We seek to start providing data driven support to businesses with ready-made verticals (ERPs, CRMs, etc.). Without bias, we want to help our customers make sense of their data cross multi-vendor applications.",
          createdAt: "2025-06-12T16:12:08.219Z",
          updatedAt: "2025-06-12T16:12:08.219Z",
          banner_image: null,
          description: null,
          documents: [],
        },
        {
          id: "20",
          is_verified: 1,
          partner_type: "sales",
          company_name: "Smart Partners Consulting",
          address_line_1:
            "Suite 306/430 Ikeja Plaza 81 Kodesho Street Ikeja Lagos",
          address_line_2: "",
          company_email: "tijani.iyemifokhae@smartpartnersng.com",
          company_website: "www.smartpartnersng.com",
          country: "Nigeria",
          state: "Lagos State",
          city: "Lagos",
          zip_code: "234",
          first_name: "Tijani",
          last_name: "Iyemifokhae",
          title: "Mr",
          personal_email: "tijani.iyemifokhae@smartpartnersng.com",
          country_code: "No Code Available",
          phone_line: "08033356651",
          core_focus:
            '["financial_solutions","human_resource","business_consulting",""]',
          solution:
            '["erp","accounting","human_resource","payroll","inventory_management","invoicing","approval_management","crm"]',
          industry:
            '["oil_gas","healthcare","hospitality","manufacturing","retail","real_estate","finance"]',
          business_size: "100+",
          resell: '[""]',
          annual_revenue: "5m",
          why_interested: "It is creative innovation platform",
          createdAt: "2025-06-10T21:14:18.527Z",
          updatedAt: "2025-06-10T21:14:18.527Z",
          banner_image: null,
          description: null,
          documents: [],
        },
      ],
      metaData: {
        total: 8,
        verified: 4,
      },
      pagination: {
        total: 8,
        page: 1,
        limit: 40,
        pages: 1,
      },
    };
  };

  const updateInvexPartner = async payload => {
    try {
      console.log(payload);
      const res = await fetch(
        `${backendUrl}/api/partnership/invexerp-partner`,
        {
          method: "PUT",
          credentials: "include",
          body: JSON.stringify(payload),
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
          },
        }
      );

      if (!res.ok) throw new Error(`Error: ${res.status} ${res.statusText}`);

      return await res.json(); // Parse response as JSON
    } catch (error) {
      console.error("Update failed:", error);
      throw error;
    }
  };

  const { data, refetch, isFetching, isSuccess } = useQuery(
    ["GET_INVEX_PARTNERS", queryParams],
    () => fetchInvexPartners(queryParams),

    {
      enabled: true,
      keepPreviousData: true,
    }
  );

  useEffect(() => {
    setPartnerList(data?.data || []);

    if (data && data.metaData) {
      let verified = data?.metaData.verified;
      navMetaData({
        stat1: {
          value: data?.metaData.total,
          label: "Total partners",
        },
        stat2: {
          value: verified,
          label: "Total verified",
        },
        stat3: {
          value: data?.metaData.total - verified,
          label: "Total unverified",
        },
      });
    }
  }, [data]);

  const debouncedFilterParams = useDebounce(filterParams, 500);
  useEffect(() => {
    setQueryParams({
      ...queryParams,
      ...debouncedFilterParams,
    });
  }, [debouncedFilterParams, setQueryParams]);

  const handleFilterParamsChange = e => {
    let searchValue = e.target.value?.toLowerCase();
    setPartnerList(() =>
      data.filter(
        ({
          company_name,
          company_email,
          first_name,
          last_name,
          personal_email,
        }) => {
          return (
            company_name.toLowerCase().includes(searchValue) ||
            company_email.toLowerCase().includes(searchValue) ||
            first_name.toLowerCase().includes(searchValue) ||
            last_name.toLowerCase().includes(searchValue) ||
            personal_email.toLowerCase().includes(searchValue)
          );
        }
      )
    );
  };
  const handleLocationChange = e => {
    let searchValue = e.target.value?.toLowerCase();
    setPartnerList(() =>
      data.filter(({ country, state, city }) => {
        return (
          country.toLowerCase().includes(searchValue) ||
          state.toLowerCase().includes(searchValue) ||
          city.toLowerCase().includes(searchValue)
        );
      })
    );
  };

  const filterByDateRange = date => {
    setFilterParams({
      ...filterParams,
      startDate: format(date[0], "yyyy-MM-dd"),
      endDate: format(date[1], "yyyy-MM-dd"),
      enableDateRange: true,
    });
  };

  const clearDateRange = () => {
    setFilterParams({
      ...filterParams,
      startDate: "",
      endDate: "",
    });
  };
  const search = () => {
    setQueryParams({
      ...queryParams,
      ...filterParams,
    });
  };

  const reset = () => {
    setFilterParams(initialFilterParams);
    setQueryParams({
      ...queryParams,
      ...initialFilterParams,
    });
  };

  const handleSearchQueryChange = e => {
    setQueryParams({
      ...queryParams,
      [e.target.name]: e.target.value,
    });
  };

  const allSelected = multiSelected.length === data?.data.length;
  const handleCheckboxChange = id => {
    setMultiSelected(
      prevSelected =>
        prevSelected.includes(id)
          ? prevSelected.filter(item => item !== id) // Remove if already selected
          : [...prevSelected, id] // Add if not selected
    );
  };

  const handleVerify = async partner => {
    try {
      if (
        await ConfirmDialog({
          description: `Are you sure you want to ${
            partner?.is_verified ? "unverify" : "verify"
          } ${
            partner
              ? "this partner"
              : "all (" + multiSelected.length + ") partners"
          }`,
        })
      ) {
        setIsLoading(true);
        if (partner !== undefined) {
          let payload = {
            id: [partner.id],
            action: { is_verified: !Boolean(partner.is_verified) },
          };
          await updateInvexPartner(payload);
        } else {
          let payload = { id: multiSelected };
          await updateInvexPartner(payload);
        }
      }
    } catch (error) {
      console.error("Error verifying:", error);
    } finally {
      await refetch();
      setMultiSelectionMode(false);
      setIsLoading(false);
    }
  };

  const fetchPartnerDashboardLink = async partner => {
    try {
      setIsLoading(true);
      const res = await fetch(
        `${backendUrl}/api/partnership/admin-auth-link/${user.Staff_ID}/${
          partner.id
        }`,
        {
          method: "GET",
          credentials: "include",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
          },
        }
      );
      if (!res.ok) throw new Error(`Error: ${res.message}`);
      const data = await res.json();
      if (data.token) {
        // redirect to the dashboard link
        window.open(
          `http://partners.invexerp.com/api/admin/auth?token=${data.token}`,
          "_blank"
        );
      } else {
        // show error message
        toast.error(data.message);
      }
    } catch (error) {
      console.error("Error fetching dashboard link:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const tableHead = () => {
    return (
      <thead className="position-sticky top-0">
        <tr>
          {multiSelectionMode && (
            <th>
              <input
                type="checkbox"
                checked={allSelected}
                onChange={e => {
                  setMultiSelected(
                    allSelected ? [] : data?.data.map(item => item.id)
                  );
                }}
              />
            </th>
          )}
          <th>
            <Button
              variant="white"
              onClick={() => {
                setMultiSelected(data?.data.map(item => item.id));
                setMultiSelectionMode(prev => !prev);
              }}
            >
              {" "}
              {/* <SettingsIcon color="white" /> */}
              {multiSelectionMode ? "Cancel" : "Select all"}
            </Button>
          </th>
          {/* <th>Company ID</th> */}

          <th>Company name</th>
          <th>Company email</th>
          <th>Personal email</th>

          <th>Country</th>
          <th>State</th>
          <th>City</th>

          <th>First Name</th>
          <th>Last Name</th>

          <th>Date Registered</th>
          <th>Approved</th>
        </tr>
      </thead>
    );
  };

  const getStatus = date => {
    const currentDate = new Date().getTime();
    let expiringDate = new Date(date);
    expiringDate.setDate(expiringDate.getDate() - 0);

    expiringDate = new Date(expiringDate).getTime();

    let timeDiff = currentDate - expiringDate;

    let daysDiff = Math.floor(timeDiff / (1000 * 3600 * 24));

    let status;

    if (daysDiff > 9) {
      status = "Suspended";
    } else {
      status = currentDate > expiringDate ? "Expired" : "Active";
    }

    return status;
  };

  function getExpiringDate(date) {
    let expDate = new Date(date);

    expDate.setDate(expDate.getDate() - 0);

    return expDate;
  }

  const tableData = (el, index) => {
    return (
      <>
        {multiSelectionMode && (
          <td>
            <input
              type="checkbox"
              checked={multiSelected.includes(el.id)}
              onChange={() => {
                handleCheckboxChange(el.id);
              }}
            />
          </td>
        )}
        <td>
          <Dropdown>
            <Dropdown.Toggle
              variant=""
              className="bg-white border-0"
              bsPrefix="print more"
            >
              <DotsVerticalIcon />
            </Dropdown.Toggle>
            <Dropdown.Menu
              popperConfig={{
                strategy: "fixed",
              }}
              renderOnMount
              className="dropdown-with-icons"
            >
              <Dropdown.Item
                as="button"
                onClick={() => {
                  setSelectedPartnerDetails(el);
                  setShowCompanyModal(true);
                }}
              >
                <ViewIcon /> View partner
              </Dropdown.Item>
              <Dropdown.Item
                as="button"
                onClick={() => {
                  handleVerify(el);

                  // setShowEmailAddressModal(true);
                }}
              >
                <Checked color="#94A3B8" />
                {el.is_verified ? "Unverify partner" : "Verify partner"}
              </Dropdown.Item>
              <Dropdown.Item
                as="button"
                onClick={() => {
                  setSelectedPartnerDetails(el);
                  setShowDocumentUploadModal(true);
                }}
              >
                <DownloadIcon />
                Upload docs{" "}
              </Dropdown.Item>
              <Dropdown.Item
                as="button"
                onClick={() => {
                  setSelectedPartnerDetails(el);
                  setShowContactPartnerModal(true);
                }}
              >
                <EmailIcon />
                Contact partner
              </Dropdown.Item>
              <Dropdown.Item
                as="button"
                onClick={() => {
                  fetchPartnerDashboardLink(el);
                }}
              >
                <CustomerAccountSelectIcon />
                Goto dashboard
              </Dropdown.Item>

              <Dropdown.Divider />

              <HoverDropDown alignRight drop="end" className="w-100">
                <Dropdown.Toggle
                  variant=""
                  className="w-100 dropdown-item justify-content-between"
                >
                  <span className="d-flex gap-2">
                    <ChartPieSliceIcon /> Partner Recruitment & Qualification
                  </span>
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item
                    onClick={() => setShowFormSelectorModal(el)}
                    as="button"
                  >
                    Send Form
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => {}} as="button">
                    Filled Forms
                  </Dropdown.Item>
                </Dropdown.Menu>
              </HoverDropDown>
            </Dropdown.Menu>{" "}
          </Dropdown>
        </td>

        {/* <td>{el?.companyID}</td> */}
        <td>{el?.company_name}</td>
        <td style={{ wordBreak: "break-all" }}>{el?.company_email}</td>
        <td style={{ wordBreak: "break-all" }}>{el?.personal_email}</td>
        <td>{el?.country}</td>
        <td>{el?.state}</td>
        <td>{el?.city}</td>
        <td>{el?.first_name}</td>
        <td>{el?.last_name}</td>

        <td>
          {el?.createdAt ? (
            <>
              <div>{`${formatDate(
                new Date(el?.createdAt),
                "dd MMM, yyyy"
              )}`}</div>
              <div
                className=""
                style={{ fontSize: "12px", fontStyle: "italic" }}
              >
                {`${formatDate(new Date(el?.createdAt), "hh:mm a")}`}
              </div>
              <div>
                {truncate(el?.lastSeenBranch, {
                  length: 15,
                })}
              </div>
            </>
          ) : (
            "..."
          )}
        </td>
        {/*
        <td>
          {!isNaN(new Date(el?.companyDateCreated).getTime())
            ? format(new Date(el?.companyDateCreated), "dd MMM, yyyy")
            : "..........."}
        </td>
        <td>
          {!isNaN(new Date(el?.companyExpiringDate).getTime())
            ? format(new Date(el?.companyExpiringDate), "dd MMM, yyyy")
            : "............"}
        </td> */}
        <td
          className={`
             "expiring-date-color  fw-bold"
            ${el?.is_verified ? "text-success fw-bold" : "text-danger fw-bold"}
          `}
          style={{ textTransform: "capitalize" }}
        >
          {String(Boolean(el?.is_verified))}
        </td>
      </>
    );
  };

  const handleSelectedForms = selectedForms => {
    console.log(selectedForms);

    // We need to send the forms to the partners
  };

  return (
    <>
      {showCompanyBranchModal && (
        <PartnerDetails
          data={selectedPartnerDetails}
          setShow={setShowCompanyModal}
        />
      )}

      {showDocumentUploadModal && (
        <DocumentUpload
          refetch={refetch}
          setShow={setShowDocumentUploadModal}
          partner={selectedPartnerDetails}
        />
      )}

      <main className="cash-book ">
        <div className="content ">
          <div className="content-main pt-3">
            <div className={`filter-area ${showFilter ? "open" : "close"}`}>
              <div className="filter-header">
                <h2>
                  <FilterTwoIcon /> Filters
                </h2>

                <Button
                  variant="white"
                  onClick={() => setShowFilter(!showFilter)}
                >
                  <FilterCollapseIcon />
                </Button>
              </div>
              <div className="filter-body">
                <Form>
                  <div className="body" style={{ height: "40em" }}>
                    <Form.Group className="mb-3 pb-2 mb-2-5">
                      <Form.Label>Campany Name</Form.Label>{" "}
                      <InputGroup>
                        <Form.Control
                          name="companyName"
                          // value={filterParams?.companyName}
                          placeholder="Enter company name"
                          onChange={e => handleFilterParamsChange(e)}
                        />{" "}
                      </InputGroup>
                    </Form.Group>

                    <Form.Group className="mb-3 pb-2 mb-2-5">
                      <Form.Label>Location</Form.Label>{" "}
                      <InputGroup>
                        <Form.Control
                          name="location"
                          // value={filterParams.companyID}
                          placeholder="Enter country, state or city"
                          onChange={e => handleLocationChange(e)}
                        />{" "}
                      </InputGroup>
                    </Form.Group>

                    <Form.Group className="mb-3 pb-2 mb-2-5">
                      <Form.Label>Filter status</Form.Label>
                      <Select
                        classNamePrefix="form-select"
                        placeholder="Filter by status"
                        isSearchable={false}
                        isClearable
                        options={partnerStatuses}
                        value={partnerStatuses.find(
                          el => el === filterParams.is_verified
                        )}
                        onChange={selected => {
                          console.log(selected);
                          setQueryParams({
                            ...filterParams,
                            page: 1,
                            is_verified: selected?.value,
                          });
                        }}
                      />
                    </Form.Group>

                    <hr className="mt-3 mb-4" />
                  </div>
                </Form>
              </div>
            </div>
            <div className="content-body">
              <header>
                <h1>
                  {!showFilter && (
                    <button
                      onClick={() => setShowFilter(!showFilter)}
                      className="btn filter"
                    >
                      <FilterTwoIcon />
                    </button>
                  )}
                  Partner List
                  <button
                    title="Refresh"
                    className="btn text-primary"
                    onClick={() => {
                      refetch();
                    }}
                  >
                    <CachedIcon />
                  </button>
                </h1>
                <div className="actions">
                  {multiSelectionMode && (
                    <Button
                      disabled={!Boolean(multiSelected.length)}
                      variant="primary"
                      onClick={() => {
                        multiSelected.length && handleVerify();
                      }}
                    >
                      Approve selected
                    </Button>
                  )}
                </div>
              </header>

              <div className="m-3">
                <TableComponent
                  responsive
                  borderless
                  striped
                  tableHeadsFunction={tableHead}
                  mainDataArray={partnerList || []}
                  className="product-table text-nowrap"
                  tableDataRowFunction={tableData}
                  // tableRowClick={(e, el) => manageTransaction(e, el)}
                />

                {!isFetching && isSuccess && isEmpty(data) ? (
                  <NoTableItem queryParams={queryParams} />
                ) : null}
              </div>

              <div className="d-flex justify-content-between px-3 align-items-center pagination">
                <div className="pagination_left">
                  <p className="m-0 p-0">Show</p>
                  <select
                    value={queryParams.limit}
                    name="limit"
                    className="form-select "
                    onChange={e => handleSearchQueryChange(e)}
                  >
                    <option value="10">10 rows</option>
                    <option value="20">20 rows</option>
                    <option value="30">30 rows</option>
                    <option value="40">40 rows</option>
                    <option value="50">50 rows</option>
                    <option value="100">100 rows</option>{" "}
                  </select>
                </div>

                <ReactPaginate
                  {...paginationOptions}
                  pageCount={Math.ceil(
                    data?.pagination?.total / queryParams.limit
                  )}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={0}
                  onPageChange={({ selected }) => {
                    document.body.scrollTop = document.documentElement.scrollTop = 0;
                    setQueryParams({
                      ...queryParams,
                      page: selected + 1,
                    });
                  }}
                  forcePage={queryParams.page - 1}
                />
              </div>
            </div>
          </div>
        </div>
      </main>

      {showContactPartnerModal && (
        <ContactPartnerModal
          partner={selectedPartnerDetails}
          setShow={setShowContactPartnerModal}
          backendUrl={backendUrl}
          token={token}
        />
      )}

      {isLoading && (
        <div className="global-spinner">
          <LoaderIcon className="spin text-primary" />
        </div>
      )}

      {showFormSelectorModal && (
        <FormSelectorModal
          showchildForm={showFormSelectorModal}
          setShowChildForm={setShowFormSelectorModal}
          handleSelectedForms={handleSelectedForms}
        />
      )}
    </>
  );
}
